export default __webpack_public_path__ + "static/nucleus-fa6d5b49a1e468a622f671e0c2c1c077.png";